import { useNavigate } from "react-router-dom";
import { fetchCartByCustomerId } from "../redux/cartSlice";

export const handlePayment = (orderResponse: any, navigate: any) => {

    if (!orderResponse) return;
    const orderId: any = orderResponse.orderId;
    //5267 3181 8797 5449
    const options = {
        key: "rzp_test_qHpBRBwDfZ5fxZ",
        amount: orderResponse.totalAmount,
        currency: "INR",
        name: "CodeGigz",
        description: "Ecommerce",
        image: "https://your-logo-url.com",
        order_id: orderResponse.razorpayOrderId,
        handler: function (response: any) {
            fetchCartByCustomerId();
            if (response && response.razorpay_payment_id && response.razorpay_payment_id != "") {
                navigate("/order-success", { state: { orderId } });
            } else {
                navigate("/order-error", { state: { orderId } });
            }
        },
        prefill: {
            name: orderResponse.customer.firstName,
            email: orderResponse.customer.email,
            contact: orderResponse.customer.mobileNumber,
        },
        modal: {
            ondismiss: function () {
                console.log("Payment was not completed. Please try again.");
                navigate("/order-error", { state: { orderId } });
            },
        },
        theme: {
            color: "#DC2626",
        },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
};